import React, { useState } from "react";
import { IconButton, Menu, MenuItem, SxProps } from "@mui/material";

export interface DropdownOption {
  label: string;
  value: string;
  onClick?: () => void;
}

export interface ActionIconButtonProps {
  icon: React.ReactNode;
  title?: string;
  onClick?: () => void;
  options?: DropdownOption[];
  sx?: SxProps;
  className?: string;
  disabled?: boolean;
}

const ActionIconButton: React.FC<ActionIconButtonProps> = ({
  icon,
  title = "",
  onClick,
  options = [],
  sx,
  className,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    if (onClick) {
      onClick();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option: DropdownOption) => {
    option.onClick?.();
    handleClose();
  };
  return (
    <>
      <IconButton
        aria-label={title}
        title={title}
        onClick={handleOpen}
        disabled={disabled}
        className={className}
        sx={{
          padding: "2px",
          fontSize: "16px",
          borderRadius: "50%",
          ...sx,
        }}
      >
        {icon}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {options.map((option, index) => (
          <MenuItem key={index} onClick={() => handleOptionClick(option)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionIconButton;
